
export function getStreak(history = []){
    if(history.length == 0) return 0;
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    const lastindex = history.length - 1;
    const lastEntry = new Date(history[lastindex].date);
    if(lastEntry.toDateString() != today.toDateString() 
    && lastEntry.toDateString() != yesterday.toDateString()) { return 0; }

    let streak = 1
    for(let i = lastindex; i>0; i--){
        const data1 = new Date(history[i].date);
        const data2 = new Date(history[i-1].date);
        const diffTime = data1 - data2; 
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if(diffDays == 1) streak++;
        else break;
        }
    

    return streak;
}

export function HowWordsCheck(e, project){
    e.preventDefault();
    const today = new Date().toISOString().split("T")[0];
    const finishDate = e.target.finishDate.value;
    const date1 = new Date(today);
    const date2 = new Date(finishDate);
    
    const diffTime = date2 - date1; 
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    const WordsGoal = project.words;
    const ActualWords = project.actualwords;
    const WordsValue = (WordsGoal - ActualWords) / diffDays;
    
    return (WordsValue.toFixed(0));
  }

export function StaticGoalCalculate(project){
    const today = new Date().toISOString().split("T")[0];
    const finishDate = project.finishDate;
    const date1 = new Date(today);
    const date2 = new Date(finishDate); 
    const diffTime = date2 - date1; 
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    const WordsGoal = project.words;
    const ActualWords = project.actualwords;
    const WordsValue = (WordsGoal - ActualWords) / diffDays;
    return (WordsValue.toFixed(0));
}

export function UpdateAutoGoal(project){
    const today = new Date().toISOString().split("T")[0];
    const finishDate = project.finishDate;
    const lastUpdate = project.setting.lastGoalUpdate;
    if(lastUpdate === today) return project; 
    const date1 = new Date(today);
    const date2 = new Date(finishDate); 
    const diffTime = date2 - date1; 
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    const WordsGoal = project.words;
    const ActualWords = project.actualwords;
    const WordsValue = (WordsGoal - ActualWords) / diffDays;
    return {
        ...project,
        settings: {
            ...project.settings,
            dailyGoal: WordsValue,
            lastGoalUpdate: today
        }
    };
}